import React from 'react'
import StatsCard from './StatsCard'
import { FaUser, FaBuilding, FaSearch } from 'react-icons/fa'
import { MdSpeakerNotes } from "react-icons/md";

const CommunityStats = () => {
  return (
    <section className='relative py-20 px-6 overflow-hidden bg-[#f8fafc]'>
      {/* Optional: Subtle Background Decorative Circles */}
      <div className="absolute top-0 left-1/4 w-64 h-64 bg-blue-100 rounded-full mix-blend-multiply filter blur-3xl opacity-30 animate-blob"></div>
      <div className="absolute bottom-0 right-1/4 w-64 h-64 bg-purple-100 rounded-full mix-blend-multiply filter blur-3xl opacity-30 animate-blob animation-delay-2000"></div>

      <div className='max-w-7xl mx-auto relative z-10'>
        <div className='text-center mb-16'>
          <h2 className='text-blue-600 font-bold tracking-widest uppercase text-sm mb-3'>Our Impact</h2>
          <h1 className='font-extrabold text-4xl sm:text-5xl text-gray-900'>
            Our Active Community
          </h1>
          <p className='text-gray-500 mt-4 max-w-xl mx-auto'>
            Growing every day. Connecting students with opportunities and experiences that matter.
          </p>
        </div>

        {/* Stats Grid */}
        <div className='grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-10'>
          <StatsCard tag="Users" count={250}>
            <FaUser size={20}/>
          </StatsCard>
          
          <StatsCard tag="Posts" count={25}>
            <MdSpeakerNotes size={22}/>
          </StatsCard>
          
          <StatsCard tag="Companies" count={10}>
            <FaBuilding size={20}/>
          </StatsCard>
          
          <StatsCard tag="Openings" count={10}>
            <FaSearch size={20}/>
          </StatsCard>
        </div>
      </div>
    </section>
  )
}

export default CommunityStats